import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService {

  clearLocalAuthData?: () => void;

  constructor(
    private router: Router
  ) {}

  handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      if (error.status == 401) {
        let msg = 'Credenciais Inválidas';
        if (this.clearLocalAuthData) {
          this.clearLocalAuthData();
        }
        if (this.router.url != '/login') {
          msg = 'Sessão expirada, favor efetuar login novamente';
          this.router.navigateByUrl('/login');
        }
        return throwError(msg);
      }

      if ((error.error) && (error.error.errors)) {
        return throwError(error.error.errors);
      }

      return throwError('Ocorreu um erro na aplicação, favor contactar o administrador');

    } else {
      console.log("Non httpErrorResponse");
    }
  }
}
